import {Injectable} from '@angular/core';
import {User} from '../models/user';
import {MonitoringType} from '../models/monitoring-type';
import {AccountType} from '../models/account-type';
import {isEUCountry} from '../data-repositories/eu-countries';

@Injectable({providedIn: 'root'})
export class MarginTypeService {

  constructor() {
  }

  public getMarginType(
    userModel: User,
    checkTrades: boolean = true,
    checkAssets: boolean = true,
    checkMarginExp: boolean = false,
  ) {
    if (userModel && userModel.dateOfBirth) {
      // Treat monitoring as Ireland when address country is in EU, even if the
      // backend value hasn't synced yet — otherwise forceCashAccountIE is ignored
      // on screens reached before the monitoring switch lands (e.g. agreements).
      // For Joint accounts: either holder being in EU triggers Ireland monitoring
      // (mirrors backend rule).
      const secondHolderInEU = userModel.accountType === AccountType.Joint &&
        isEUCountry(userModel.secondHolder?.addressModel?.countryName);
      const effectiveMonitoring = userModel.monitoring === MonitoringType.Ireland ||
        isEUCountry(userModel.addressModel?.countryName) ||
        secondHolderInEU
        ? MonitoringType.Ireland
        : MonitoringType.USA;

      const forceCash = effectiveMonitoring === MonitoringType.Ireland
        ? userModel.forceCashAccountIE
        : userModel.forceCashAccountUS;

      if (forceCash) {
        return 'Cash';
      }

      const splitedDate = userModel.dateOfBirth.split('/');
      const dateOfBirth = new Date(Number(splitedDate[2]), Number(splitedDate[1]) - 1, Number(splitedDate[0]));

      let youngestHolderAge = this.getAge(new Date(dateOfBirth));

      if (userModel.accountType === AccountType.Joint && userModel.secondHolder?.dateOfBirth) {
        const splitedDate2 = userModel.secondHolder.dateOfBirth.split('/');
        const dateOfBirth2 = new Date(Number(splitedDate2[2]), Number(splitedDate2[1]) - 1, Number(splitedDate2[0]));
        youngestHolderAge = Math.min(youngestHolderAge, this.getAge(new Date(dateOfBirth2)));
      }

      if (effectiveMonitoring === MonitoringType.Ireland) {
        return youngestHolderAge < 21 ||
        checkAssets &&
        (
          +userModel.assetsModel.netInCome < 3 ||
          +userModel.assetsModel.liquidNetWorth < 3
        ) ||
        checkAssets &&
        (
          (+userModel.assetsModel.netInCome < 3 && userModel.baseCurrency === 'EUR') ||
          (+userModel.assetsModel.liquidNetWorth < 2 && userModel.baseCurrency === 'EUR')
        ) ||
        (checkTrades &&
          +userModel.investmentModel.stocks.yearsTrading * +userModel.investmentModel.stocks.tradesPerYear < 20
        ) ||
        +userModel.investmentModel.stocks.yearsTrading < 2 ||
        userModel.investmentModel.stocks.knowledgeLevel === 'Limited' ||
        (checkMarginExp && !userModel.investmentModel.stocks.marginExperience)
          ? 'Cash'
          : 'Margin';
      }

      return youngestHolderAge < 21 ||
      +userModel.assetsModel.netInCome < 2 ||
      +userModel.assetsModel.liquidNetWorth < 3 ||
      (+userModel.assetsModel.netInCome < 2 && userModel.baseCurrency === 'EUR') ||
      (+userModel.assetsModel.liquidNetWorth < 2 && userModel.baseCurrency === 'EUR')
        ? 'Cash'
        : 'Margin';
    }

    return '???';
  }

  private getAge(dateOfBirth: Date): number {
    const today = new Date();
    const a = (today.getFullYear() * 100 + today.getMonth()) * 100 + today.getDate();
    const b = (dateOfBirth.getFullYear() * 100 + dateOfBirth.getMonth()) * 100 + dateOfBirth.getDate();
    return (a - b) / 10000;
  }
}
